/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Custom_Page_Icon_CommentsiconInputs */

const en_enum_custom_page_icon_commentsicon = /** @type {(inputs: Enum_Custom_Page_Icon_CommentsiconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comments`)
};

const de_enum_custom_page_icon_commentsicon = /** @type {(inputs: Enum_Custom_Page_Icon_CommentsiconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentare`)
};

/**
* | output |
* | --- |
* | "Comments" |
*
* @param {Enum_Custom_Page_Icon_CommentsiconInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_custom_page_icon_commentsicon = /** @type {((inputs?: Enum_Custom_Page_Icon_CommentsiconInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Custom_Page_Icon_CommentsiconInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_custom_page_icon_commentsicon(inputs)
	return de_enum_custom_page_icon_commentsicon(inputs)
});